"use strict";

/**
 * Уведомление для панели уведомлений.
 * 
 * @class WebAccess.components.notifications.Notification
 * @extends BaseObject
 * @since 5.8.2.9000
 */
(function (global) {
  var Notification = BaseObject.extend({
    id: null,
    icon: '',
    title: '',
    text: '',
    deadline: '',
    background: '',
    link: '',
    new: false,

    notificationTypesToOpenDialog: ['mail'],

    /**
     * Инициализирует объект уведомления.
	   * @function WebAccess.components.notifications.Notification.init
     * @param {Object} ntfData Данные уведомления
     */
    init: function (ntfData) {
      this._super();

      this.id = ntfData.id;
      this.icon = ntfData.icon;
      this.title = ntfData.title;
      this.text = ntfData.text;
      this.deadline = ntfData.deadline;
      this.background = ntfData.background;
      this.link = ntfData.link;
      this.new = ntfData.new;
    },

    /**
     * Формирует разметку уведомления.
	   * @function WebAccess.components.notifications.Notification.render
     * */
    render: function () {
      this.html = `<div id="${this.id}" class="notification${this.new ? ' new' : ''}" ${this.background && this.background.length? 'style="background: ${this.background};"' : ''} ${this.getOnClickAttr()}>
        <div class="head">
          <div style="display: inline-block; float: left">
            ${this.icon ? '<svg class="notification-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#' + this.icon + '-32"></use></svg>' : ''}
            <span class="notification-title" ${!(this.deadline && this.deadline.length) ? 'style="width:350px"' : ''} title="${this.title.escapeHtml()}">${this.title.escapeHtml()}</span>
          </div>
          <div style="display: inline-block; float: right">
            ${this.deadline && this.deadline.length ? '<span>' + L('DEADLINE') + ': ' + formatDateTime(new Date(this.deadline)) + '</span>' : ''}
            <div class="notification-close-button" title="${L('DELETE')}" onClick="window.event.cancelBubble = true; event.stopPropagation(); document.ntfPanel.deleteNtf('${this.id}'); ">
              <span class="ui-icon-closethick"></span>
            </div>
          </div>
        </div>
        <p>${this.text.escapeHtml()}</p></div>`;
    },

    /**
     * Возвращает HTML-атрибут обработчика клика по уведомлению.
     * @function WebAccess.components.notifications.Notification.getOnClickAttr
     * */
    getOnClickAttr: function () {
      var onclick = `document.ntfPanel.markRead('${this.id}');`;
      if (!this.notificationTypesToOpenDialog.includes(this.icon)) {
        // разнесено специально, чтобы не открывать диалог как попало
        if (this.link && this.link.length) {
          onclick += `window.open('${this.link}', '${this.id}');`;
        }
      } else {
        onclick += `var d = new WA.CMP.dialogs.MessageBox();
                   d.showInfo('${this._escapeSpecial(this.text)}'.escapeHtml(), '', '${this._escapeSpecial(this.title)}'.escapeHtml());
                   if (d._jDialog.width() > 800) { d.setWidth(800); }`;
      }
      return `onClick="${onclick}"`;
    },

    /**
     * Экранирует спецсимволы js кода для разметки.
     * @function _escapeSpecial
     * @param {string} str Экранируемая строка.
     * @returns {string} Экранированная строка.
     */
    _escapeSpecial: function (str) {
      var entityMap = {
        '"': '&#34;',
        "'": '\\\'',
        "\\": '\\\\'
      };

      return String(str).replace(/["'\\]/g, (s) => {
        return entityMap[s];
      });
    }

  });

  global.Notification = Notification;

})(window.WebAccess.components.notifications);